import {useEffect, useId, useState} from "react";
import '../../../static/css/pages/login/login.css';
import {Link, useNavigate} from "react-router-dom";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {PostJSON} from "../../../components/api/webservice";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {Apis} from "../../../components/api/url";

export const AdminsLoginScreen = () => {
    useEffect(() => {
        document.title = "ورود مدیران | نهال";
        HideMainLoading();
        PostJSON(
            Apis.server + '/core/admins/account/info',
            {},
            true,
            (d:{
                result:string,
                reason:string|undefined,
            })=>{
                if(d.result === 'OK'){
                    navigate('/admins/',{replace:true});
                }
            },
            ()=>{},
            ()=>{},
        ).then(void 0);
    }, []);
    const ids = {
        userName: useId(),
        passWord: useId(),
    };
    const [err, setErr] = useState({
        username: false,
        password: false,
    });
    const [userName, setUserName] = useState('');
    const [passWord, setPassWord] = useState('');
    let navigate = useNavigate();
    const tryLogin = () => {
        let un = userName.trim();
        const pw = passWord.trim();
        let errors = {
            username: false,
            password: false,
        };
        let stop = false;
        if (un.length !== 11) {
            errors.username = true;
            stop = true;
        }
        if (pw.length < 2) {
            errors.password = true;
            stop = true;
        }
        setErr(errors);
        if (stop)
            return;
        un = '+98' + un.substring(1);
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/account/login',
            {
                t: un,
                p: pw,
            },
            false,
            (d: {
                result: string,
                reason: string | undefined,
                tk: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    ShowSnackbar('نام‌کاربری یا گذرواژه اشتباه می‌باشد.', 'باشه', 5000);
                    return;
                }
                localStorage.setItem('myAuth', d.tk);
                navigate('/admins/', {replace: true});
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            () => {
            },
        ).then(void 0);
    };
    return (
        <>
            <div className="login-screen" style={{backgroundImage: `url(https://tstatic.ir/apps/tclass/teachers/teachers-login-bg.jpg)`}} data-aos="fade"
                 data-aos-duration={1000}>
                <div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-8">
                                <div className="login-card" data-aos="zoom-in-up" data-aos-duration={600}
                                     data-aos-delay={300}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div style={{padding:10}}>
                                                <div className="login-card-logo">
                                                    <em style={{backgroundImage: `url(/logo.png)`}}/>
                                                    <b>ورود مدیران</b>
                                                    <span className="f-roboto">دبستان مهارتی نهال</span>
                                                </div>
                                                <div className="login-form">
                                                    <label htmlFor={ids.userName} className="f-roboto">تلفن همراه:</label>
                                                    <input
                                                        id={ids.userName}
                                                        type="tel"
                                                        className={"form-control f-roboto" + (err.username ? ' is-invalid' : '')}
                                                        value={userName}
                                                        onChange={e => {
                                                            const t = e.currentTarget.value;
                                                            setUserName(t);
                                                            setErr(v => {
                                                                let x = {...v};
                                                                x.username = false;
                                                                return x;
                                                            });
                                                        }}
                                                        onKeyUp={e => {
                                                            if (e.which === 13)
                                                                (document.getElementById(ids.passWord) as HTMLInputElement).focus();
                                                        }}
                                                    />
                                                    <div
                                                        className={"invalid-feedback f-roboto " + (err.username ? 'd-block' : 'd-none')}>
                                                        لطفا تلفن را بصورت ۱۱ رقمی وارد کنید.
                                                    </div>
                                                    <div style={{height: 20}}/>
                                                    <label htmlFor={ids.passWord} className="f-roboto">گذرواژه:</label>
                                                    <input
                                                        id={ids.passWord}
                                                        type="password"
                                                        className={"form-control f-roboto" + (err.password ? ' is-invalid' : '')}
                                                        value={passWord}
                                                        style={{direction:'ltr'}}
                                                        onChange={e => {
                                                            const t = e.currentTarget.value;
                                                            setPassWord(t);
                                                            setErr(v => {
                                                                let x = {...v};
                                                                x.password = false;
                                                                return x;
                                                            });
                                                        }}
                                                        onKeyUp={e => {
                                                            if (e.which === 13)
                                                                tryLogin();
                                                        }}
                                                    />
                                                    <div
                                                        className={"invalid-feedback f-roboto " + (err.password ? 'd-block' : 'd-none')}>
                                                        لطفا این سطر را تکمیل کنید.
                                                    </div>
                                                    <div className="login-card-cta">
                                                        <button onClick={tryLogin}>
                                                            <span>ورود به حساب</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="login-copyright">
                                            <span
                                                className="f-roboto">تمام حقوق برای دبستان نهال محفوظ است.</span>
                                                    <div>
                                                        <Link to="/signin">ورود والدین</Link>
                                                        <Link to={"/"}>وبسایت نهال</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 d-none d-lg-inline-block">
                                            <div className="login-news-img">
                                                <div style={{backgroundImage: `url(/images/cover-login.png)`}}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};